import { API_HOST } from '../../config';
import { buildPath } from './buildPath';

export type ISearchParams = Record<string, string | string[] | number | number[]>;

export interface IBuildRequestConfig<SearchParams = ISearchParams, Body = Record<string, unknown>> {
  host?: string;
  path: string | ((body: Body) => string);
  headers?: HeadersInit;
  searchParams?: SearchParams;
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  body?: FormData | Body | string;
  accepts?: string;
  contents?: string;
}

export default function buildRequest<SearchParams = ISearchParams, Body = Record<string, unknown>>({
  // eslint-disable-next-line no-restricted-globals
  host = API_HOST,
  path,
  searchParams,
  headers: headersInit,
  accepts,
  contents = 'application/json',
  method = 'GET',
  body,
}: IBuildRequestConfig<SearchParams, Body>) {
  const headers = new Headers(headersInit);

  const url = new URL(buildPath(typeof path === 'function' ? path(body as Body) : path, host));

  if (searchParams) {
    Object.entries(searchParams).forEach(([key, values]) => {
      url.searchParams.delete(key);

      (Array.isArray(values) ? values : [values]).forEach((value) => {
        if (value !== undefined && value !== null && value !== '') {
          url.searchParams.append(key, String(value));
        }
      });
    });
  }

  if (body) {
    if (!(body instanceof FormData)) {
      if (typeof body !== 'string') {
        body = JSON.stringify(body);
      }

      if (contents) {
        headers.set('Content-Type', contents);
      }
    }
  }

  if (accepts) {
    headers.set('Accept', accepts);
  }

  return new Request(url.toString(), {
    method,
    body: body as string | FormData | undefined,
    // credentials: 'include',
    headers,
  });
}
